import { AuthcadResource } from '@mark43/cad-api';
import { disManager } from '@m43/core';
import { type TypeBoundAxiosInstance } from '@m43/shared';
import { logErrorMessage } from '../monitoring/log';
import { getRealUrlPrefix } from './auth-state';

/**
 * Tears down the session and redirects to the correct login screen.
 *
 * Which login screen depends on the app the user is currently in, which we infer
 * from the pathname rather than from app config — the legacy and next apps are
 * served from the same origin.
 */
export async function logout(
    apiClient?: TypeBoundAxiosInstance,
    ssoV2LogoutUrl?: string
): Promise<void> {
    if (apiClient) {
        const csrfToken = localStorage.getItem('csrfToken');
        if (csrfToken) {
            try {
                await apiClient.request<AuthcadResource.DeleteSession>({
                    method: 'DELETE',
                    url: `auth/cad/sessions/${csrfToken}/`,
                });
            } catch (e) {
                // continue logout
            }
        }
    }
    localStorage.removeItem('csrfToken');
    if (disManager.getIsStarted()) {
        const maybePromise = disManager.logout();
        if (maybePromise) {
            try {
                await maybePromise;
            } catch (e) {
                logErrorMessage('Error logging out of DIS');
            }
        }
    }

    if (ssoV2LogoutUrl) {
        (window as Window).location = ssoV2LogoutUrl;
        return;
    }

    const isCadNextPath = window?.location.pathname?.includes('/cad-next');
    if (isCadNextPath) {
        (window as Window).location = `${getRealUrlPrefix()}/cad-next/login`;
        return;
    }
    const isFirstResponderNextPath = window?.location.pathname?.includes('/first-responder-next');
    if (isFirstResponderNextPath) {
        (window as Window).location = `${getRealUrlPrefix()}/first-responder-next/login`;
        return;
    }
    const isFirstResponderPath = window?.location.pathname?.includes('/first-responder');
    if (isFirstResponderPath) {
        (window as Window).location = `${getRealUrlPrefix()}/first-responder/login`;
    }
}
